import { MiddlewareFunction } from '@segment/analytics-next'
import { AppEnv, env } from 'config'
import { isMaestroTest } from 'utils/maestro'
import { EXPERIMENTS } from './experimentConfig'
import { getPinnedExperimentVariant } from './experimentStorage'

const EXPERIMENT_PROPERTY_PREFIX = 'exp_'

const resolveExperimentProperty = (flag: string): [string, string] | null => {
  const pinned = getPinnedExperimentVariant(flag)

  if (!pinned) {
    return null
  }

  return [`${EXPERIMENT_PROPERTY_PREFIX}${flag}`, pinned]
}

// Example output:
// { exp_experiment_video_calls_pilot_web_members: 'variant' }
export const getActiveExperimentProperties = (): Record<string, string> => {
  if (isMaestroTest()) {
    return {}
  }

  return Object.fromEntries(
    EXPERIMENTS.map(({ flag }) => resolveExperimentProperty(flag)).filter(
      (entry): entry is [string, string] => entry !== null
    )
  )
}

export const experimentTrackingMiddleware: MiddlewareFunction = ({ payload, next }) => {
  const { type } = payload.obj

  // Add the variant to page/track events so reports can split data by variant.
  if (type === 'track' || type === 'page') {
    const experimentProperties = getActiveExperimentProperties()

    payload.obj.properties = {
      ...experimentProperties,
      ...payload.obj.properties
    }

    if (Object.keys(experimentProperties).length > 0) {
      logExperimentDebug(`middleware stamped ${type} "${payload.obj.event ?? payload.obj.name}"`, {
        ...experimentProperties
      })
    }
  }

  next(payload)
}

export const logExperimentDebug = (message: string, details?: unknown) => {
  if (env.REACT_APP_ENV !== AppEnv.Production) {
    // eslint-disable-next-line no-console
    console.debug(`[experiment] ${message}`, details ?? '')
  }
}
